import React from "react";
import "./Skeleton.css";

export function Skeleton({ className = "", style = {} }) {
  return <span className={`ui-skeleton ${className}`.trim()} style={style} aria-hidden="true" />;
}

export function TableSkeleton({ rows = 8, cols = 6, className = "" }) {
  return (
    <div className={`manage-card table-responsive ${className}`.trim()}>
      <table className="manage-table align-middle mb-0">
        <thead>
          <tr>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={`h-${i}`}>
                <Skeleton className="ui-skeleton-line ui-skeleton-th" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={`r-${r}`}>
              {Array.from({ length: cols }).map((__, c) => (
                <td key={`c-${r}-${c}`}>
                  <Skeleton className="ui-skeleton-line" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ProductCardSkeleton({ count = 9, list = false, className = "" }) {
  return (
    <div className={`${list ? "products-grid list-view" : "products-grid"} ${className}`.trim()}>
      {Array.from({ length: count }).map((_, i) => (
        <article className={`product-card ${list ? "list-layout" : ""}`} key={`p-skel-${i}`}>
          <div className="product-image-placeholder">
            <Skeleton className="ui-skeleton-media" />
          </div>
          <div className="product-content">
            <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
            <Skeleton className="ui-skeleton-line ui-skeleton-w-85" />
            <Skeleton className="ui-skeleton-line ui-skeleton-w-45" />
            <Skeleton className="ui-skeleton-line ui-skeleton-w-35" />
            <Skeleton className="ui-skeleton-btn" />
          </div>
        </article>
      ))}
    </div>
  );
}

export function CardGridSkeleton({ count = 6, className = "" }) {
  return (
    <div className={`ui-skeleton-card-grid ${className}`.trim()}>
      {Array.from({ length: count }).map((_, i) => (
        <div className="ui-skeleton-card" key={`card-skel-${i}`}>
          <Skeleton className="ui-skeleton-media ui-skeleton-media-sm" />
          <div className="ui-skeleton-card-body">
            <Skeleton className="ui-skeleton-line ui-skeleton-w-70" />
            <Skeleton className="ui-skeleton-line ui-skeleton-w-45" />
            <Skeleton className="ui-skeleton-btn" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function CartListSkeleton({ rows = 4 }) {
  return (
    <div className="ui-skeleton-cart">
      <div className="ui-skeleton-section-head">
        <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
        <Skeleton className="ui-skeleton-line ui-skeleton-w-15" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div className="ui-skeleton-cart-row" key={`cart-skel-${i}`}>
          <Skeleton className="ui-skeleton-thumb" />
          <div className="ui-skeleton-cart-info">
            <Skeleton className="ui-skeleton-line ui-skeleton-w-70" />
            <Skeleton className="ui-skeleton-line ui-skeleton-w-35" />
          </div>
          <Skeleton className="ui-skeleton-line ui-skeleton-w-15" />
          <Skeleton className="ui-skeleton-line ui-skeleton-w-20" />
        </div>
      ))}
      <div className="ui-skeleton-cart-summary">
        <Skeleton className="ui-skeleton-line ui-skeleton-w-45" />
        <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
        <Skeleton className="ui-skeleton-btn" />
      </div>
    </div>
  );
}

export function ProductDetailsSkeleton() {
  return (
    <div className="ui-skeleton-pdp">
      <div className="ui-skeleton-pdp-gallery">
        <Skeleton className="ui-skeleton-media ui-skeleton-pdp-main" />
        <div className="ui-skeleton-pdp-thumbs">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton className="ui-skeleton-thumb" key={`pd-thumb-${i}`} />
          ))}
        </div>
      </div>
      <div className="ui-skeleton-pdp-info">
        <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
        <Skeleton className="ui-skeleton-line ui-skeleton-title" />
        <Skeleton className="ui-skeleton-line ui-skeleton-w-45" />
        <Skeleton className="ui-skeleton-line ui-skeleton-w-85" />
        <Skeleton className="ui-skeleton-line ui-skeleton-w-70" />
        <div className="ui-skeleton-pdp-actions">
          <Skeleton className="ui-skeleton-btn" />
          <Skeleton className="ui-skeleton-btn" />
        </div>
      </div>
    </div>
  );
}

export function HomePageSkeleton() {
  return (
    <div className="ui-skeleton-home">
      <Skeleton className="ui-skeleton-hero" />
      <div className="ui-skeleton-section">
        <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
        <Skeleton className="ui-skeleton-line ui-skeleton-title" />
        <CardGridSkeleton count={4} />
      </div>
      <div className="ui-skeleton-section">
        <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
        <Skeleton className="ui-skeleton-line ui-skeleton-title" />
        <ProductCardSkeleton count={4} />
      </div>
    </div>
  );
}

export function FormPageSkeleton() {
  return (
    <div className="ui-skeleton-form-page">
      <Skeleton className="ui-skeleton-line ui-skeleton-title" />
      <Skeleton className="ui-skeleton-line ui-skeleton-w-70" />
      <div className="ui-skeleton-form-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div className="ui-skeleton-form-field" key={`form-skel-${i}`}>
            <Skeleton className="ui-skeleton-line ui-skeleton-w-30" />
            <Skeleton className="ui-skeleton-input" />
          </div>
        ))}
      </div>
      <Skeleton className="ui-skeleton-btn" />
    </div>
  );
}
